import { PayloadAction } from "@reduxjs/toolkit";
import { Provider, ProviderState } from "types/Provider";

const setProviders = (
  state: ProviderState,
  action: PayloadAction<Provider[]>
): void => {
  state.providers = action.payload;
};
const setProvidersCards = (
  state: ProviderState,
  action: PayloadAction<any>
): void => {
  state.providersCards = action.payload;
};
const setProvidersCollection = (
  state: ProviderState,
  action: PayloadAction<any>
): void => {
  state.providersCollection = action.payload;
};
const reducers = {
  setProviders,
  setProvidersCards,
  setProvidersCollection,
};

export default reducers;
